"use strict";
/**
 * Created on 10 15 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var ExportedPriceWithValidity_1 = require("../model/ExportedPriceWithValidity");

var ExportedPriceWithValidityConverter_1 = require("./ExportedPriceWithValidityConverter");
/**
 * <p>Implementation of {@link ExportedPriceWithValidityConverter}.</p>
 *
 * @author JMe
 */


var ExportedPriceWithValidityConverterImpl =
/*#__PURE__*/
function (_ExportedPriceWithVal) {
  _inherits(ExportedPriceWithValidityConverterImpl, _ExportedPriceWithVal);

  function ExportedPriceWithValidityConverterImpl() {
    _classCallCheck(this, ExportedPriceWithValidityConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ExportedPriceWithValidityConverterImpl).apply(this, arguments));
  }

  _createClass(ExportedPriceWithValidityConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        value: conversions.asObject(source, 'value', function (v) {
          return conversions.fromBigNumber(v);
        }),
        valueRounded: conversions.asObjectOpt(source, 'valueRounded', function (v) {
          return conversions.fromBigNumber(v);
        }),
        validFrom: conversions.asObject(source, 'validFrom', function (v) {
          return conversions.fromDate(v);
        }),
        validTo: conversions.asObjectOpt(source, 'validTo', function (v) {
          return conversions.fromDate(v);
        }),
        deleted: source.deleted
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ExportedPriceWithValidity_1.ExportedPriceWithValidity(conversions.asObject(source, 'value', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'valueRounded', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObject(source, 'validFrom', function (v) {
        return conversions.toDate(v);
      }), conversions.asObjectOpt(source, 'validTo', function (v) {
        return conversions.toDate(v);
      }), conversions.asObject(source, 'deleted', function (v) {
        return utils_1.Utils.asBool(v);
      }));
    }
  }]);

  return ExportedPriceWithValidityConverterImpl;
}(ExportedPriceWithValidityConverter_1.ExportedPriceWithValidityConverter);

exports.ExportedPriceWithValidityConverterImpl = ExportedPriceWithValidityConverterImpl;